import { create } from "zustand";
import { useInvoices } from "../../useInvoices";
import moment from "moment";
import api from "../../../../../api";
import { showToast } from "../../../../../Components/Toast";
export let useInvoicesHeader = create((set, get) => ({
  filter: {
    vesselId: "*",
    vesselName: "*",
    department: "*",
    userId: "*",
    date: new Date(),
    status: "*",
    dueDate: "*",
    dueDateRange: "*",
    filterName: "issueDate",
    from: "*",
    to: "*",
    searchNotPosted: false,
    currency: "*",
  },

  dateFilterTitle: "Select Date Filter",
  dateFilterName: "noInvoiceFilter", //invoiceIssueDate",
  dateFilterRange: null,
  checkedNotPosted: false,

  searchValues: {
    invoiceId: undefined,
    invoiceNumber: undefined,
  },

  overdueInvoices: null,
  dueIn7Days: null,
  latestSearchRequest: null,
  generatingRL: false,

  setFilterNameField: (dateFilterName) => {
    set({ dateFilterName });
  },

  setFilterDepartment: (department) => {
    set({ filter: { ...get().filter, department } });
  },

  setDateFilterRange: (dateFilterRange) => {
    if (dateFilterRange == null) dateFilterRange = [null, null];
    set({ dateFilterRange });
  },

  clearDateFilterRange: () => {
    set({
      dateFilterTitle: "Select Date Filter",
      dateFilterRange: null,
      checkedNotPosted: false,
      filter: {
        ...get().filter,

        filterName: "noInvoiceFilter",
        searchNotPosted: false,
        from: undefined,
        to: undefined,
      },
    });
  },

  onClickNotPosted: (status) => {
    set({ checkedNotPosted: !status });
  },

  applyDateFilter: () => {
    const dateFilterName = get().dateFilterName;
    let dateFilterRange = get().dateFilterRange;
    if (dateFilterName == "noInvoiceFilter") {
      showToast("e", "Please select a date filter name");
      return;
    }

    if (dateFilterRange == null) {
      showToast("e", "Please select a date range");
      return;
    }
    let from = undefined;
    let to = undefined;

    let title = "";
    let dateFrom = undefined;
    let dateTo = undefined;
    let searchNotPosted = get().checkedNotPosted;

    if (dateFilterRange[0] != null) {
      from = moment.utc(dateFilterRange[0]).startOf("day").toDate();
      dateFrom = moment.utc(dateFilterRange[0]).format("DD/MM/YYYY");
    }

    if (dateFilterRange[1] != null) {
      to = moment.utc(dateFilterRange[1]).endOf("day").toDate();
      dateTo = moment.utc(dateFilterRange[1]).format("DD/MM/YYYY");
    }
    // } else {
    //   dateFilterRange = ["*", "*"];
    // }

    if (dateFilterName == "invoiceIssueDate")
      title = `Invoice Issue Date: ${dateFrom} - ${dateTo}`;
    if (dateFilterName == "invoiceDueDate")
      title = `Invoice Due Date: ${dateFrom} - ${dateTo}`;
    if (dateFilterName == "invoiceApprovedDate")
      title = `Invoice Approved Date: ${dateFrom} - ${dateTo}`;
    if (dateFilterName == "invoicePaidDate")
      title = `Invoice Paid Date: ${dateFrom} - ${dateTo}`;
    if (dateFilterName == "invoicePostedDate")
      title = `Invoice Posted Date: ${dateFrom} - ${dateTo}`;
    if (dateFilterName == "noInvoiceFilter") {
      title = "Select Date Filter";
      from = undefined;
      to = undefined;
    }

    set({
      dateFilterTitle: title,
      filter: {
        ...get().filter,
        searchNotPosted,
        filterName: dateFilterName,
        from,
        to,
      },
    });

    // set({
    //   dateFilterTitle: title + " " + dateFrom + " - " + dateTo,
    // });
    // console.log(get().dateFilterRange);
  },
  currencyHandler: (currency) => {
    set({ filter: { ...get().filter, currency: currency } });
  },
  vesselHandler: (value) => {
    set({ filter: { ...get().filter, vesselName: value } });
  },

  userHandler: (value) => {
    set({ filter: { ...get().filter, userId: value } });
  },

  statusHandler: (value) => {
    set({ filter: { ...get().filter, status: value } });
  },

  departmentHandler: (value) => {
    set({ filter: { ...get().filter, department: value } });
  },

  searchInputHandler: (value, e) => {
    let { getInvoices, setTableLoading } = useInvoices.getState();

    setTableLoading(true);

    let { searchValues, latestSearchRequest } = get();
    let id = e.target.id;

    set({ searchValues: { ...searchValues, [id]: value } });

    //console.log(searchValues);
    if (latestSearchRequest) {
      clearTimeout(latestSearchRequest);
    }

    latestSearchRequest = setTimeout(() => {
      useInvoices.setState({ activePage: 1 });
      getInvoices();
      setTableLoading(false);
    }, 500);

    set({ latestSearchRequest });
  },

  searchClearHandler: (id) => {
    let { getInvoices, setTableLoading } = useInvoices.getState();
    setTableLoading(true);
    let { searchValues, latestSearchRequest } = get();
    set({ searchValues: { ...searchValues, [id]: "" } });
    if (latestSearchRequest) {
      clearTimeout(latestSearchRequest);
    }
    latestSearchRequest = setTimeout(() => {
      useInvoices.setState({ activePage: 1 });
      getInvoices();
      setTableLoading(false);
    }, 500);
    set({ latestSearchRequest });
  },

  handleClearCompany: () => {
    let { searchValues, latestSearchRequest } = get();
    set({ searchValues: { ...searchValues, company: undefined } });
    if (latestSearchRequest) {
      clearTimeout(latestSearchRequest);
    }
  },
  periodFromHandler: (v, e) => {
    if (!v) return;
    let from = moment(v).utc().startOf("day").format();
    set({ filter: { ...get().filter, from } });
  },

  periodToHandler: (v, e) => {
    if (!v) return;
    let to = moment(v).utc().endOf("day").format();
    set({ filter: { ...get().filter, to } });
    console.log(get().filter);
  },

  dueDateHandler: (value) => {
    let fromDate = moment().utc().startOf("day").format(); //.toDate()

    let dueDate = value;
    if (value == "Overdue") dueDate = fromDate;
    if (value == "1 day") dueDate = moment(fromDate).utc().add(1, "d").format();
    if (value == "3 days")
      dueDate = moment(fromDate).utc().add(3, "d").format();
    if (value == "7 days")
      dueDate = moment(fromDate).utc().add(7, "d").format();
    if (value == "14 days")
      dueDate = moment(fromDate).utc().add(14, "d").format();

    console.log("dueDate: " + dueDate);
    set({ filter: { ...get().filter, dueDateRange: value, dueDate } });
  },

  getDueData: async () => {
    let response = await api.invoices.getDueInvoiceCounts();

    let { overdueInvoices, dueIn7Days } = response;

    set({ overdueInvoices, dueIn7Days });
  },

  onExport: async () => {
    const { filter, searchValues } = get();
    let { invoicesArrayLength } = useInvoices.getState();

    const options = {
      ...filter,
      ...searchValues,
    };

    //set({ generatingRL: true });
    if (!invoicesArrayLength) {
      showToast(
        "e",
        "No invoices were found. Please update the search filters"
      );
      return;
    }

    if (invoicesArrayLength > 500) {
      showToast(
        "e",
        "Maximum export is 500 invoices. Please update the search filters."
      );
      return;
    }
    const response = await api.invoices.generateInvoicesExcel(options);

    const fileBlob = response.data;
    if (fileBlob) {
      const now = new Date();
      const day = String(now.getDate()).padStart(2, "0");
      const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are zero-based
      const year = now.getFullYear();
      const hour = String(now.getHours()).padStart(2, "0");
      const minute = String(now.getMinutes()).padStart(2, "0");
      const filename = `Export_Invoices_${day}-${month}-${year}_${hour}-${minute}.xlsx`;
      const blob = new Blob([fileBlob], { type: fileBlob.type });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } else {
      showToast("e", "Error generating invoice export file");
    }
    set({ generatingRL: false });
  },
}));

const unsubscribe = useInvoicesHeader.subscribe((newState, prevState) => {
  if (prevState.filter !== newState.filter) {
    useInvoices.setState({ activePage: 1 });
    useInvoices.getState().getInvoices();
  }
});
